// import { useState, useEffect, useContext } from "react";
import styled, { css, keyframes } from "styled-components/macro";
import { Row } from "react-bootstrap";
// import { useRouter } from "next/router";

import device from "src/styles/device";
import { convertIntToCurrency } from "src/common";
import { IconCartNew, IconDelivery, IconInstaller } from "src/icons";

// import {
//   IconMaterialAlbum,
//   IconBgASA,
//   IconTrash,
//   IconCartNew,
//   IconDelivery,
//   IconInstaller,
// } from "Icons";
// import ReactGA from "react-ga4";

// import { ModalContext } from "context/ModalContext";
// import { LoadingContext } from "context/LoadingContext";
// import { replaceProductUrl } from "lib/common";
import {
  Secondary,
  Green,
  DarkGrey,
  Primary,
  Black,
  Violet,
  White,
} from "src/styles/color";
import { IconXclusiveDealOnCard } from "src/icons/IconExclusiveDealCard";
// import i18next from "i18next";
// import { Rating } from "react-simple-star-rating";
// import { gtag, install } from "ga-gtag";
// import { getCountQuotationCartByUser, updateCart } from "api/cart";
// import { NavbarContext } from "context/NavbarContext";

const fly_to_cart = keyframes`
  to {
    transform: scale(0.08);
    top: var(--top);
    left: var(--left);
  }
`;

const marginCarousel = css`
  margin-top: 5px;
  margin-bottom: 5px;
`;

const ProductCard = styled.div`
  width: 100%;
  height: auto;
  position: relative;
  ${({ carousel }) => carousel && marginCarousel};
  transition: 0.2s;

  /* > .image-carior.active {
    z-index: 10000000;
    > img {
      position: absolute;
      top: 0;
      left: 0;
      animation: ${fly_to_cart} 0.7s ease-in;
      z-index: 10000000;
    }
  } */
`;

const Card = styled.div`
  width: 100%;
  background-color: ${White};
  /* box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.2); */
  transition: 0.3s;
  border-radius: 12px;
  padding: 8px;

  :hover {
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);
    /* transform: scale(1.01); */
  }

  @media ${device.mobileL} {
    border-radius: 12px;
  }
`;

const WrapperImage = styled.div`
  width: 100%;
  padding-top: 100%;
  position: relative;
  border-radius: 8px;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: inherit;
  transition: 0.3s;
  border-radius: 8px;
`;

const WrapperDetail = styled.div`
  border-radius: 8px;
`;

const RowItemcodeView = styled(Row)`
  align-items: center;
  position: relative;
  width: 55%;
`;

const GradientItemCode = styled.div`
  background: linear-gradient(
    360deg,
    rgba(37, 37, 37, 0.4) 0%,
    rgba(37, 37, 37, 0) 100%
  );
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  height: 35px;
  display: flex;
  align-items: center;
  border-radius: 0 0 8px 8px;
`;

const ItemCode = styled.span`
  text-align: left;
  font-size: 0.75rem;
  color: ${({ color }) => (color ? "#6c6c70" : "#FFFFFF")};
  font-weight: 400;
  line-height: 15px;
  border-radius: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: "Poppins", "Prompt";
  padding-left: 15px;
  padding-right: 15px;

  @media ${device.mobileL} {
    font-size: 0.625rem;
  }
`;

const RowFirst = styled.div`
  display: flex;
  width: 100%;
  //justify-content: space-between;
  /* padding: 10px 15px 2px 15px; */
  padding: 10px 0 0 0;
  position: relative;
  /* 
  @media ${device.tabletL} {
    padding: 10px 15px 2px 15px;
  }
  @media ${device.mobileL} {
    padding: 8px 10px 0px 10px;
  } */
`;

const DivItemNameAndSellerName = styled.div`
  font-family: "Poppins", "Prompt";
  width: 100%;
`;

const LabelItemName = styled.div`
  font-weight: 500;
  line-height: 18px;
  height: 36px;
  color: ${Black};
  font-size: 0.75rem;
  font-family: "Poppins", "Prompt";
  /* width: 100%; */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  white-space: normal;

  @media ${device.mobileL} {
    font-size: 0.75rem;
  }
`;

const LabelSellerName = styled.div`
  text-align: left;
  font-weight: 400;
  color: ${DarkGrey};
  font-size: 0.625rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 5px;

  @media ${device.mobileL} {
    font-size: 0.75rem;
  }
`;

const RowFifth = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  position: relative;
  margin-top: 8px;

  @media ${device.mobileL} {
    /* padding: 4px 10px 0px 10px; */
  }
`;

const WrapperOldPrice = styled.div`
  margin-top: auto;
  margin-bottom: auto;
  height: 15px;
  width: 100%;
  text-align: left;
  margin-bottom: 2px;
`;

const WrapperPrice = styled.div`
  width: 100%;
`;

const LabelPrice = styled.span`
  font-family: "Prompt", "Poppins";
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  max-width: 100%;
  font-size: 1.25rem;
  color: ${({ specialprice }) => (specialprice ? Primary : Black)};
  margin-right: 3%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: normal;

  @media ${device.tabletL} {
    font-size: 1rem;
  }
  @media ${device.mobileL} {
    font-size: 0.875rem;
  }
`;

const LabelPriceSmall = styled.div`
  font-family: "Prompt";
  font-style: normal;
  font-weight: 400;
  font-size: 0.625rem;
  color: ${(props) => (props.specialprice ? Primary : "#6C6C70")};
  text-decoration: ${(props) => (props.isLineThrough ? "line-through" : null)};
`;

const LabelCurrency = styled.div`
  font-size: 0.625rem;
  color: ${({ specialprice }) => (specialprice ? Primary : "#6C6C70")};
  font-weight: 400;
  margin-right: 3%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: "Prompt", "Poppins";
  padding-top: 4px;
  height: 24px;
  @media ${device.tabletL} {
    font-size: 0.75rem;
  }
  @media ${device.mobileL} {
    /* font-size: 0.625rem; */
  }
`;

const RowThird = styled.div`
  width: 100%;
  display: flex;
  padding: 0 15px 0 15px;
  height: 15px;
  text-align: left;
  @media ${device.tabletL} {
    padding: 0 15px 0 15px;
  }
  @media ${device.mobileL} {
    padding: 0 10px 0 10px;
  }
`;

const LabelCate = styled.div`
  font-size: 0.625rem;
  color: #6c6c70;
  font-weight: 400;
  line-height: 15px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: "Prompt", "Poppins";
`;

const RowFourth = styled.div`
  width: 100%;
  /* font-family: 'Prompt', 'Poppins'; */
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  color: ${Black};
  font-size: 0.625rem;
  height: 12px;
  margin-top: 7px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  @media ${device.mobileL} {
    font-size: 0.625rem;
    /* padding: 0 10px 0 10px; */
  }
`;

const LabelDiscount = styled.div`
  position: absolute;
  top: 17%;
  left: 5%;
  background: #d70015;
  padding: 3px 8px;
  z-index: 1;
  color: #ffffff;
  font-weight: 400;
  font-size: 0.625rem;
  line-height: 15px;
  border-radius: 4px;

  &::before {
    background: #d9d9d9;
    border-radius: 100%;
    content: "";
    display: block;
    position: absolute;
    width: 5px;
    height: 5px;
    top: 10%;
    left: 5%;
  }

  @media only screen and (max-width: 860px) {
    top: 20%;
  }
`;

const WrapperIconBgASA = styled.div`
  position: absolute;
  top: 5%;
  left: 5%;
  z-index: 1;
`;

const PriceUnitFlex = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-top: -8px;
`;

const ClickProductCard = styled.a`
  display: ${({ flex }) => flex && "flex"};
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const RowRating = styled.div`
  width: 100%;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  margin: 8px 0;
  height: 22px;
`;

const ButtonAddToCart = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 100%;
  background-color: ${Secondary};
  cursor: pointer;
  padding: 0;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  position: absolute;
  bottom: 10px;
  right: 10px;
`;

const SectionPrice = styled.div`
  display: flex;
  width: 70%;
  align-items: flex-end;
`;

const LabelDelivery = styled.div`
  background: #d3eadd;
  border: 1px solid ${Green};
  color: ${Green};
  padding: 3px 4px 2px 4px;
  border-radius: 6px;
  font-size: 8px;
  font-weight: 500;
  line-height: 16px;
  display: flex;
  align-items: center;
`;

const LabelInstall = styled.div`
  background: #e0d4f9;
  border: 1px solid ${Violet};
  color: ${Violet};
  padding: 3px 4px 2px 4px;
  border-radius: 6px;
  font-size: 8px;
  font-weight: 500;
  line-height: 16px;
  display: flex;
  align-items: center;
  margin-left: ${({ isMargin }) => isMargin && "5px"};
`;

const ProductCardElement = ({
  src,
  srcHover = null,
  itemcode,
  itemname,
  mode,
  price = null,
  productType,
  isPin,
  view,
  id,
  brand,
  choice_id,
  color,
  texture,
  size,
  carousel,
  newTab,
  unit,
  discount,
  isExclusiveDeal,
  colorCode,
  sellerLogo,
  sellerName,
  display = false,
  onClickDelete,
  isInstall = false,
  isDelivery = false,
  isSell = false,
  isInstock = false,
}) => {
  //   const router = useRouter();
  //   const [isMode, setIsMode] = useState(0);
  //   const [pinMode, setPinMode] = useState(true);
  //   const { setCountCart } = useContext(NavbarContext);

  //   const {
  //     auth: { setAuthInfo },
  //     album: { setAlbumInfo },
  //     alert: { setAlertInfo },
  //   } = useContext(ModalContext);

  //   const { setIsLoading } = useContext(LoadingContext);

  //   useEffect(() => {
  //     if (mode) setIsMode(mode);
  //   }, [mode]);

  //   useEffect(() => {
  //     if (isPin != undefined) setPinMode(isPin);
  //   }, [isPin]);

  // const handleClickPin = (id) => {
  //   const token = window.localStorage.getItem("access_token");

  //   if (token != null) {
  //     const { Pin_board: rolePin } = JSON.parse(
  //       window.localStorage.getItem("user_role")
  //     );
  //     if (rolePin) {
  //       // pinboard.setVisible(true)
  //       // pinboard.setProductChoiceId(id)
  //       // setAlbumInfo((conf) => ({
  //       //   ...conf,
  //       //   visible: true,
  //       //   productChoiceId: id,
  //       // }));
  //     }
  //   } else {
  //     //   setAuthInfo((conf) => ({
  //     //     ...conf,
  //     //     visible: true,
  //     //   }));
  //   }
  // };

  const handleClickProductDetail = () => {
    // return replaceProductUrl(
    //   `${brand}-${itemcode}-${encodeURIComponent(itemname)}=${id}`
    // );
  };

  return (
    <>
      <ProductCard carousel={carousel} srcHover={srcHover}>
        {/* {display && (
          <ButtonDelete onClick={() => onClickDelete()}>
            <IconTrash />
          </ButtonDelete>
        )} */}

        {newTab === undefined || newTab === false ? (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a target="_self">
            <Card>
              <WrapperDetail>
                <WrapperImage>
                  <ClickProductCard
                    flex
                    href={handleClickProductDetail()}
                    // onClick={() => setIsLoading(true)}
                  >
                    <Image
                      src={src}
                      id="img-product-card"
                      alt={`${itemname} (${itemcode})`}
                    />
                  </ClickProductCard>

                  <ClickProductCard
                    flex
                    href={handleClickProductDetail()}
                    // onClick={() => setIsLoading(true)}
                  >
                    <GradientItemCode>
                      <ItemCode
                        color={
                          colorCode === "6397f5d042db124ebd33eca9" ||
                          colorCode === "63c90c049d945fef0df81dc8" ||
                          (colorCode === "6397f5d042db124ebd33eca4" && true)
                        }
                      >
                        {itemcode}
                      </ItemCode>
                    </GradientItemCode>
                  </ClickProductCard>

                  {isExclusiveDeal && (
                    <WrapperIconBgASA>
                      <IconXclusiveDealOnCard />
                    </WrapperIconBgASA>
                  )}

                  {discount && discount > 0 && discount < 100 ? (
                    <LabelDiscount>{`- ${Math.floor(
                      discount
                    )}%`}</LabelDiscount>
                  ) : null}

                  {/* <WrapperIconPin
                    onClick={() => {
                      handleClickPin(choice_id);
                    }}
                  >
                    <IconMaterialAlbum
                      id="icon-album"
                      width="20"
                      height="20"
                      fill={Primary}
                    />
                  </WrapperIconPin> */}
                </WrapperImage>

                <ClickProductCard
                  flex
                  href={handleClickProductDetail()}
                  //   onClick={() => setIsLoading(true)}
                >
                  <RowFirst>
                    <DivItemNameAndSellerName>
                      <LabelItemName>{itemname}</LabelItemName>
                      <LabelSellerName>{productType}</LabelSellerName>
                    </DivItemNameAndSellerName>
                  </RowFirst>
                </ClickProductCard>

                {/* <RowThird>
                    <LabelCate>{productType}</LabelCate>
                  </RowThird> */}
                <ClickProductCard
                  href={handleClickProductDetail()}
                  //   onClick={() => setIsLoading(true)}
                >
                  <RowFourth>
                    {typeof size !== "string"
                      ? // size object
                        size?.quantity === "capacity"
                        ? `${size?.capacity_size} 
                          ${size?.unit_capacity?.unit_th}`
                        : size?.quantity === "size"
                        ? !size.width && !size.height && !size?.thickness
                          ? ""
                          : `${size?.width ? size?.width : ""}
                          ${
                            size.unit_width.unit_th
                              ? size.unit_width.unit_th
                              : ""
                          } 
                          ${size?.width ? "x" : ""} 
                          ${size?.height ? size.height : ""}
                          ${
                            size.unit_height.unit_th
                              ? size.unit_height.unit_th
                              : ""
                          } 
                          ${size?.height ? "x" : ""} 
                          ${size?.thickness ? size?.thickness : "-"}
                          ${
                            size?.unit_thickness?.unit_th
                              ? size?.unit_thickness?.unit_th
                              : ""
                          }`
                        : ""
                      : size}
                  </RowFourth>
                </ClickProductCard>

                <ClickProductCard
                  flex
                  href={handleClickProductDetail()}
                  //   onClick={() => setIsLoading(true)}
                >
                  <RowRating>
                    {isDelivery && (
                      <LabelDelivery>
                        <IconDelivery fill={Green} />
                        จัดส่งฟรี
                      </LabelDelivery>
                    )}

                    {isInstall && (
                      <LabelInstall isMargin={isDelivery}>
                        <IconInstaller
                          color={Violet}
                          width={15}
                          height={10}
                          style={{ marginRight: "3px" }}
                        />
                        ติดตั้งฟรี
                      </LabelInstall>
                    )}
                    {/* <div style={{ display: 'flex', alignContent: 'center' }}>
                      <IconStarFill
                        style={{ marginRight: '1px' }}
                        width={13}
                        height={13}
                        // fill={GreyStroke}
                      />

                      <QuantityRating>{`(${'100'})`}</QuantityRating>
                    </div> */}
                  </RowRating>
                </ClickProductCard>

                <ClickProductCard
                  flex
                  href={handleClickProductDetail()}
                  //   onClick={() => setIsLoading(true)}
                >
                  <RowFifth>
                    <>
                      {!!price &&
                      price.start_price === 0 &&
                      price.price === 0 &&
                      price.special_price === 0 ? (
                        <WrapperPrice>
                          <WrapperOldPrice />
                          <LabelCurrency>{"สอบถามเพิ่มเติม"}</LabelCurrency>
                        </WrapperPrice>
                      ) : price?.is_start_price ? (
                        <WrapperPrice>
                          <WrapperOldPrice>
                            <LabelPriceSmall>
                              {"ราคาเริ่มต้นที่"}
                            </LabelPriceSmall>
                          </WrapperOldPrice>
                          <PriceUnitFlex>
                            <SectionPrice>
                              <LabelPrice>
                                {`฿${convertIntToCurrency(
                                  price.start_price,
                                  false
                                )}`}
                              </LabelPrice>

                              <LabelCurrency specialprice={false}>
                                {<>/{price.unit_price.unit_th}</>}
                              </LabelCurrency>
                            </SectionPrice>
                          </PriceUnitFlex>
                        </WrapperPrice>
                      ) : price?.special_price === 0 && price?.price === 0 ? (
                        <WrapperPrice>
                          <WrapperOldPrice />
                          <LabelCurrency>{"สอบถามเพิ่มเติม"}</LabelCurrency>
                        </WrapperPrice>
                      ) : price?.special_price < price?.price &&
                        price?.special_price !== 0 &&
                        price?.special_price !== null ? (
                        <WrapperPrice>
                          <WrapperOldPrice>
                            <LabelPriceSmall isLineThrough={true}>
                              {`฿${convertIntToCurrency(price?.price, false)}`}
                            </LabelPriceSmall>
                          </WrapperOldPrice>
                          <PriceUnitFlex>
                            <SectionPrice>
                              <LabelPrice specialprice={true}>
                                {`฿${
                                  convertIntToCurrency(
                                    price?.special_price,
                                    false
                                  )
                                  // String(
                                  //   convertIntToCurrency(
                                  //     price?.special_price,
                                  //     false,
                                  //   ),
                                  // ).split('.').length > 1
                                  //   ? convertIntToCurrency(
                                  //       price?.special_price,
                                  //       false,
                                  //     )
                                  //   : +convertIntToCurrency(
                                  //       price?.special_price,
                                  //       false,
                                  //     )
                                }`}
                              </LabelPrice>
                              <LabelCurrency specialprice={false}>
                                {<>/{price?.unit_price?.unit_th}</>}
                              </LabelCurrency>
                            </SectionPrice>
                          </PriceUnitFlex>
                        </WrapperPrice>
                      ) : (
                        <WrapperPrice>
                          <WrapperOldPrice />
                          <PriceUnitFlex>
                            <SectionPrice>
                              <LabelPrice>
                                {`฿${convertIntToCurrency(
                                  price?.price,
                                  false
                                )}`}
                              </LabelPrice>
                              <LabelCurrency specialprice={false}>
                                {<>/{price?.unit_price?.unit_th}</>}
                              </LabelCurrency>
                            </SectionPrice>
                          </PriceUnitFlex>
                        </WrapperPrice>
                      )}
                      {/* <WrapperOrder>
                              <LabelPriceSmall>
                                ขายได้ 1,000
                              </LabelPriceSmall>
                            </WrapperOrder>   
                            <WrapperRating>
                              <FontRating>
                                4.5 ✰
                              </FontRating>
                              
                            </WrapperRating> */}
                    </>
                  </RowFifth>
                </ClickProductCard>
              </WrapperDetail>

              {isSell && isInstock && (
                <ButtonAddToCart onClick={(e) => {}}>
                  <IconCartNew width={19} height={17} fill={Primary} />
                </ButtonAddToCart>
              )}
            </Card>
          </a>
        ) : (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a>
            <Card>
              <WrapperDetail>
                <RowItemcodeView>
                  <ItemCode>{itemcode}</ItemCode>
                </RowItemcodeView>

                {/* <RowItemName>
                  <LabelItemName>{itemname}</LabelItemName>
                </RowItemName> */}

                <RowThird>
                  <LabelCate>{productType}</LabelCate>
                </RowThird>
              </WrapperDetail>

              <WrapperImage>
                <Image src={src} alt={`${itemname} (${itemcode})`} />
              </WrapperImage>
            </Card>
          </a>
        )}
      </ProductCard>
    </>
  );
};

export default ProductCardElement;
